import { FC } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { FillingExperience } from '@frontend/digital-forms-ui';

const routeApi = getRouteApi('/form-preview');

export const FormPreviewPage: FC = () => {
  const { companyId = '', formId, packetId, templateId } = routeApi.useSearch();

  if (formId) {
    return <FillingExperience.Preview.PublicForm documentId={formId} locationId={companyId} />;
  }

  if (packetId) {
    return <FillingExperience.Preview.PublicPacket documentId={packetId} locationId={companyId} />;
  }

  if (templateId) {
    return <FillingExperience.Preview.Template documentId={templateId} locationId={companyId} />;
  }

  return <FillingExperience.FormNotFound variant='link-broken' locationId={companyId} />;
};
